/*
  km-angebot-tracking.js · Kirchberger Metall (28.10.2026, Account 1)

  Macht Online-Angebote, aus denen Auftraege werden, in Google Ads messbar
  (Plan: km-projekte/projekte/angebots-conversions/2026-10-28-plan.md).

  1. Haengt an jede Angebotsanfrage an n8n (Webhooks km-konfigurator-angebot und
     km-produkt-angebot) das Feld "tracking" an: Werbe-Einwilligung und - nur mit
     Einwilligung - die Klick-IDs von Google (gclid, gbraid, wbraid) und Microsoft
     (msclkid). n8n schreibt sie in den Entwurfsauftrag, von dort gehen sie in die
     Bestellung ueber.
  2. Meldet eine erfolgreich angelegte Anfrage als dataLayer-Ereignis
     "angebot_angefordert" mit den Kontaktdaten im Stape-Format user_data (fuer den
     GTM-Tag "Angebot angefordert", erweiterte Conversions). Ohne Werbe-Einwilligung
     wird nichts gemeldet.

  Bewusst als Huelle um window.fetch gebaut: die Angebotsformulare (Konfigurator,
  Koeln, Gelaender, Vordach, Produktseite, Warenkorb) bleiben unveraendert. Jeder Fehler
  hier faellt auf den unveraenderten Aufruf zurueck - eine Anfrage darf nie an dieser
  Datei scheitern.
*/
(function () {
  if (!window.fetch || window.kmAngebotTracking) return;

  var ZIEL = /\/webhook\/km-(konfigurator|produkt)-angebot\/?(\?|$)/;
  var VORWAHL = { DE: '49', AT: '43', CH: '41', LU: '352', NL: '31', BE: '32', FR: '33', IT: '39', CZ: '420' };

  function werbungErlaubt() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() === true;
    } catch (e) {}
    return false; // unbekannt zaehlt als nein
  }

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  // _gcl_aw / _gcl_gb haben das Format GCL.<Zeitstempel>.<Klick-ID>
  function ausGcl(name) {
    var t = cookie(name).split('.');
    return t.length >= 3 ? t.slice(2).join('.') : '';
  }

  function param(name) {
    try { return new URLSearchParams(window.location.search).get(name) || ''; } catch (e) { return ''; }
  }

  function sauber(v) {
    return String(v || '').replace(/[^A-Za-z0-9_\-.]/g, '').slice(0, 200);
  }

  function daten() {
    var ok = werbungErlaubt();
    var t = { werbung: ok, seite: String(window.location.pathname || '').slice(0, 150) };
    if (!ok) return t;
    t.gclid = sauber(param('gclid') || ausGcl('_gcl_aw'));
    t.gbraid = sauber(param('gbraid') || ausGcl('_gcl_gb'));
    t.wbraid = sauber(param('wbraid'));
    t.msclkid = sauber(param('msclkid') || cookie('_uetmsclkid').replace(/^_uet/, ''));
    return t;
  }

  // Telefon in E.164 (+49...). Was sich nicht sicher umwandeln laesst, bleibt weg.
  function telefon(roh, land) {
    var t = String(roh || '').replace(/[^\d+]/g, '');
    if (!t) return '';
    if (t.indexOf('00') === 0) t = '+' + t.slice(2);
    if (t.charAt(0) === '+') return /^\+\d{8,15}$/.test(t) ? t : '';
    var v = VORWAHL[String(land || 'DE').toUpperCase()];
    if (v && t.charAt(0) === '0') {
      t = '+' + v + t.replace(/^0+/, '');
      return /^\+\d{8,15}$/.test(t) ? t : '';
    }
    return '';
  }

  function melden(kunde, typ) {
    if (!werbungErlaubt()) return;
    var k = kunde || {};
    var land = String(k.land || 'DE').toUpperCase();
    var ud = {
      email: String(k.email || '').trim().toLowerCase(),
      first_name: String(k.vorname || '').trim(),
      last_name: String(k.nachname || '').trim(),
      street: String(k.strasse || '').trim(),
      city: String(k.ort || '').trim(),
      zip: String(k.plz || '').trim(),
      country: land
    };
    var tel = telefon(k.telefon, land);
    if (tel) ud.phone = tel;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'angebot_angefordert', angebot_typ: typ, user_data: ud });
  }

  var original = window.fetch;

  window.fetch = function (eingabe, init) {
    var url = '';
    try { url = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || ''; } catch (e) {}
    var treffer = url && ZIEL.exec(url);
    if (!treffer || !init || String(init.method || 'GET').toUpperCase() !== 'POST' || typeof init.body !== 'string') {
      return original.apply(window, arguments);
    }

    var kunde = null;
    var neu = init;
    try {
      var nutzlast = JSON.parse(init.body);
      kunde = nutzlast.kunde || null;
      nutzlast.tracking = daten();
      neu = Object.assign({}, init, { body: JSON.stringify(nutzlast) });
    } catch (e) {
      neu = init;
    }

    return original.call(window, eingabe, neu).then(function (antwort) {
      try {
        if (antwort && antwort.ok) {
          antwort.clone().json().then(function (j) {
            if (j && j.ok === true) melden(kunde, treffer[1]);
          }).catch(function () {});
        }
      } catch (e) {}
      return antwort;
    });
  };

  // Fuer die Pruefung in der Vorschau (Konsole): kmAngebotTracking.daten()
  window.kmAngebotTracking = { daten: daten, telefon: telefon, version: '2026-10-28' };
})();
